import React from 'react';
import { Link } from 'react-router-dom';
import Request from '../../Models/Request';

import { Header, Footer } from '../Common';
import { SideBar } from '../Common/SideBar';
// import { connect } from 'react-redux';
// import { buyerLogin } from '../../../Action/login';

class RequestDetailsSeller extends React.Component {
    constructor(props) {
        super(props);
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        this.state = {
            minHeight: "475px",
            RequestList: [],
            requestdetails: [],
            responselist: [],
            request: [],
            requestAll: [],
            existing: [],
            accepted: '',
            count: '',
            id: logged_user.id,
            body: '',
            bodyalt: ''
        };
        this.getResponseAll();
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    getResponseAll() {
        Request.getRequestResponse(this.props.location.state.id).then(res => {
            this.setState({ requestdetails: res.data.request })
            this.setState({ responselist: res.data.response })
            this.setState({ accepted: res.data.accepted_id })
            this.setState({ body: res.data.request.long_desc })
            this.setState({ bodyalt: res.data.request.content })
        })
        Request.getRequestDetail(this.props.location.state.id, this.state.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ request: res.data.payload })
                this.setState({ requestAll: res.data.requestall })
                this.setState({ count: res.data.count })
                this.setState({ existing: res.data.existing_response })
            }
        })
    }

    updateField(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSubmit(e) {
        // console.log('asd')
        e.preventDefault();
        let data = {
        }
        console.log(data);
    }

    existingRequest() {
        if (this.state.existing.length > 0) {
            return (
                <div className="card" style={{ width: "100%" }}>
                    {this.state.existing.map(group =>
                        <div className="card-body" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                            <div className="row">
                                <div className="col-md-12 mb-1">見積り詳細: &nbsp;
                                    {group.content.split('\n').map(function (item, key) {
                                    return (
                                        <span key={key}>
                                            {item}
                                            <br />
                                        </span>
                                    )
                                })}
                                </div>
                            </div>
                            <div className="row mb-1">
                                <div className="col-md-12">
                                    見積価格: {group.estimated_price}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    完成予定日: {group.estimated_deadline.substring(0, 11)}
                                </div>
                            </div>
                            <br />
                        </div>
                    )}
                </div>
            )
        }
    }

    productsTitle() {
        if (this.state.requestdetails.product_id) {
            if (this.state.requestdetails.budget_range !== null) {
                return (
                    <Link to={{
                        pathname: `/categories-details/${this.state.requestdetails.product_id}`,
                        state: { id: this.state.requestdetails.product_id }
                    }} className="col-md-12">
                        {this.state.requestdetails.pro_title}
                    </Link>
                )
            } else {
                return (
                    <div className=""></div>
                )
            }
        } else {
            return (
                <div className=""></div>
            )
        }
    }

    description() {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (this.state.requestdetails.budget_range === null) {
            return (
                <div className="card" style={{ border: '0px solid', backgroundColor: '#f4f2f0' }}>
                    {/* {renderHTML(this.state.body)} */}
                    {this.state.body.split('\n').map((item, key) =>
                        <span key={key}>
                            {renderHTML(item)}
                            <br />
                        </span>
                    )}
                </div>
            )
        } else {
            return (
                <div className="card" style={{ border: '0px solid', backgroundColor: '#f4f2f0' }}>
                    {/* {renderHTML(this.state.bodyalt)} */}
                    {this.state.bodyalt.split('\n').map((item, key) =>
                        <span key={key}>
                            {renderHTML(item)}
                            <br />
                        </span>
                    )}
                </div>
            )
        }
    }

    title() {
        if (this.state.requestdetails.budget_range === null) {
            return (
                <div className="">
                    <Link to={{
                        pathname: `/categories-details/${this.state.requestdetails.product_id}`,
                        state: { id: this.state.requestdetails.product_id }
                    }} className="">
                        {this.state.requestdetails.pro_title}
                    </Link>
                </div>
            )
        } else {
            return (
                <div className="">
                    {this.state.requestdetails.title}
                </div>
            )
        }
    }

    pageStatus() {
        if (this.state.requestdetails.current_status === 'TRADING') {
            return (
                <div >
                    <div className="card pages_contents" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                        <div className=" row card-body" >
                            <div className="col-md-12 ">
                                <Link to={{ pathname: `/buyer-my-profile-view/users/${this.state.requestdetails.buyer_id}`, state: { id: this.state.requestdetails.buyer_id } }} className="row">
                                    <div className="col-md-12"><b>{this.state.requestdetails.buyer}</b></div>
                                </Link>
                                <br />
                                <div className="row">
                                    {this.productsTitle()}
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">取引日</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.state.requestdetails.created_at.substring(0, 11)}</b></div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">取引金額</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.state.requestdetails.proposed_budget} 円</b></div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">サービス名</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.title()}</b></div>
                                </div>
                            </div>
                            <div className="card-body col-md-12"> <span>{this.description()}</span></div>
                        </div>
                    </div>
                    &nbsp;
                    {this.existingRequest()}
                </div>
            )
        } else if (this.state.requestdetails.current_status === 'COMPLETE' || this.state.requestdetails.current_status === 'CANCEL') {
            return (
                <div >
                    <div className="card pages_contents" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                        <div className=" row card-body" >
                            <div className="col-md-12 ">
                                <Link to={{ pathname: `/buyer-my-profile-view/users/${this.state.requestdetails.buyer_id}`, state: { id: this.state.requestdetails.buyer_id } }} className="row">
                                    <div className="col-md-12"><b>{this.state.requestdetails.buyer}</b></div>
                                </Link>
                                <br />
                                <div className="row">
                                    {this.productsTitle()}
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">取引日</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.state.requestdetails.created_at.substring(0, 11)}</b></div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">取引金額</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.state.requestdetails.proposed_budget} 円</b></div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">サービス名</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.title()}</b></div>
                                </div>
                            </div>
                            <div className="card-body col-md-12"> <span>{this.description()}</span></div>
                        </div>
                    </div>
                    &nbsp;
                    {this.existingRequest()}
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div> */}
                            <div className="col-md-12" style={{ fontSize: "13px" }}>
                                <div className="mt-5 input_name big_font text-left" style={{ width: '100%',fontSize:'20px' }}>
                                    取引詳細
                                </div>
                                <div>
                                    {this.pageStatus()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left" style={{ width: '100%' }}>
                                            取引詳細
                                    </div>
                                        <div>
                                            {this.pageStatus()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
    }
}

// const mapStateToProps = (state) => ({
//     buyerLogin: state.buyerLogin,
// });

// BuyerLogin = connect(mapStateToProps, { buyerLogin })(BuyerLogin);

export { RequestDetailsSeller };


